/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientIdentityDeletionTaskStatsForPeriod } from './';
import {
    ClientIdentityDeletionTaskStatsForPeriodFromJSON,
    ClientIdentityDeletionTaskStatsForPeriodFromJSONTyped,
    ClientIdentityDeletionTaskStatsForPeriodToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientIdentityDeletionTaskStats
 */
export interface ClientIdentityDeletionTaskStats {
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    currentMonth: ClientIdentityDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    currentWeek: ClientIdentityDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    over3Months: ClientIdentityDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    pastMonth: ClientIdentityDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    pastPastMonth: ClientIdentityDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    pastWeek: ClientIdentityDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {ClientIdentityDeletionTaskStatsForPeriod}
     * @memberof ClientIdentityDeletionTaskStats
     */
    sinceTheBeginning: ClientIdentityDeletionTaskStatsForPeriod;
}

/**
 * Check if a given object implements the ClientIdentityDeletionTaskStats interface.
 */
export function instanceOfClientIdentityDeletionTaskStats(value: object): value is ClientIdentityDeletionTaskStats {
    if (!('currentMonth' in value) || value['currentMonth'] === undefined) return false;
    if (!('currentWeek' in value) || value['currentWeek'] === undefined) return false;
    if (!('over3Months' in value) || value['over3Months'] === undefined) return false;
    if (!('pastMonth' in value) || value['pastMonth'] === undefined) return false;
    if (!('pastPastMonth' in value) || value['pastPastMonth'] === undefined) return false;
    if (!('pastWeek' in value) || value['pastWeek'] === undefined) return false;
    if (!('sinceTheBeginning' in value) || value['sinceTheBeginning'] === undefined) return false;
    return true;
}

export function ClientIdentityDeletionTaskStatsFromJSON(json: any): ClientIdentityDeletionTaskStats {
    return ClientIdentityDeletionTaskStatsFromJSONTyped(json, false);
}

export function ClientIdentityDeletionTaskStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientIdentityDeletionTaskStats {
    if (json == null) {
        return json;
    }
    return {
        
        'currentMonth': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['currentMonth']),
        'currentWeek': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['currentWeek']),
        'over3Months': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['over3Months']),
        'pastMonth': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['pastMonth']),
        'pastPastMonth': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['pastPastMonth']),
        'pastWeek': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['pastWeek']),
        'sinceTheBeginning': ClientIdentityDeletionTaskStatsForPeriodFromJSON(json['sinceTheBeginning']),
    };
}

export function ClientIdentityDeletionTaskStatsToJSON(value?: ClientIdentityDeletionTaskStats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentMonth': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['currentMonth']),
        'currentWeek': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['currentWeek']),
        'over3Months': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['over3Months']),
        'pastMonth': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['pastMonth']),
        'pastPastMonth': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['pastPastMonth']),
        'pastWeek': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['pastWeek']),
        'sinceTheBeginning': ClientIdentityDeletionTaskStatsForPeriodToJSON(value['sinceTheBeginning']),
    };
}

